import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const sendMailEscaladoAseguradora = async (payload) => {
    try {
        const response = await mainAxios.post(
            `/v1/escalar/aseguradora/mail`,
            payload,
            getDefaultHeaders()
        );

        return response;
    } catch (error) {
        console.warn(error);
        return error.response.data
    }
};

export const actualizarPolizaAseguradoraRenovacion = async (id) => {
    try {
        const response = await mainAxios.get(
            `/v1/emision/renovar/actualizar/${id}`,
            getDefaultHeaders()
        );

        return response.data;
    } catch (error) {
        console.warn(error);
        throw error; 
    }
};

export const emitirPolizaSinCodigo = async ({ emisionId }) => {
    try {
        const response = await mainAxios.get(
            `/v1/bradescard/validar/${emisionId}`,
            getDefaultHeaders()
        );

        return response.data.data;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};

export const emitirPolizaConCodigo = async (globalId, codigo) => {
    try {
        const response = await mainAxios.post(
            `/v1/bradescard/validar/codigo/${globalId}`, codigo,
            getDefaultHeaders()
        );

        return response.data.data;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};

export const cancelarEmision = async (emisionId, body) => {
    try {
        const response = await mainAxios.post(
            `/v1/emision/${emisionId}/cancelar`,body,
            getDefaultHeaders()
        );

        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(getErrorMessage(error));
    }
};

export const getEmisionById = async (uuid) => {
    try {
        const response = await mainAxios.get(
            `/v1/emision/id/${uuid}`,
            getDefaultHeaders()
        );

        return response.data;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};

export const reenviarCertificado = async (globalInteractionId) => {
    try {
        const response = await mainAxios.get(
            `/v1/bradescard/poliza/reenviar/${globalInteractionId}`,
            getDefaultHeaders()
        );
        return response.data;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};


export const reactivarPoliza = async (emisionId) => {
    try {
        const response = await mainAxios.put(
            `/v1/emision/${emisionId}/reactivar`, {},
            getDefaultHeaders()
        );
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
};

export const obtenerCertificado = async (emisionId) => {
    try {
        const response = await mainAxios.post(
            `/v1/emision/${emisionId}/certificado`,{},
            getDefaultHeaders()
        );

        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(getErrorMessage(error));
    }
};

export const aplicarEndoso = async (emisionId, body) => {
    try {
        const response = await mainAxios.post(
            `/v1/emision/${emisionId}/endoso`,body,
            getDefaultHeaders()
        );

        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(getErrorMessage(error));
    }
};

export const regenerarCuotas = async (emisionId) => {
    try {
        const response = await mainAxios.post(
            `/v1/emision/${emisionId}/cuotas/regenerar`,{},
            getDefaultHeaders()
        );

        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(getErrorMessage(error));
    }
};